var render = function render(){var _vm=this,_c=_vm._self._c;return _c('valid-van-field',{attrs:{"label":_vm.label,"placeholder":_vm.placeholder,"rules":_vm.reg,"readonly":_vm.readonly,"type":_vm.type,"maxlength":_vm.maxlength},model:{value:(_vm.col),callback:function ($$v) {_vm.col=$$v},expression:"col"}})
}
var staticRenderFns = []

export { render, staticRenderFns }